import { Id } from "@dgs/core";
import { FC } from "react";
import { ApplicationType } from "../../../../shared/types";
import { DeepApplicationConfiguration } from "../../../../shared/types/application";
import { CreateDeepApplicationDrawer } from "./CreateDeepApplicationDrawer";
import { CreateKronosApplicationDrawer } from "./CreateKronosApplicationDrawer";
import { CreateParticipantManagementApplicationDrawer } from "./CreateParticipantManagementApplicationDrawer";

interface Props {
	open: boolean;
	onClose: () => void;
	applicationType: ApplicationType;
	config: DeepApplicationConfiguration | null;
	eventId: Id;
}

export const CreateApplicationDrawer: FC<Props> = ({ applicationType, config, ...rest }) => {
	switch (applicationType) {
		case ApplicationType.DEEP:
			return <CreateDeepApplicationDrawer config={config || { enableApp: false, enableFrontend: true }} {...rest} />;
		case ApplicationType.PARTICIPANT_MANAGEMENT:
			return <CreateParticipantManagementApplicationDrawer {...rest} />;
		case ApplicationType.KRONOS:
			return <CreateKronosApplicationDrawer {...rest} />;
	}

	return null;
};
